"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const lodash_es_1 = require("lodash-es");
const useEventListener_1 = __importDefault(require("../../../hooks/useEventListener"));
const useKeyEvent_1 = __importDefault(require("../../../hooks/useKeyEvent"));
const keyCodes_1 = require("../../../constants/keyCodes");
const useIconScreenReaderAccessProps_1 = __importDefault(require("../../../hooks/useIconScreenReaderAccessProps"));
const KEYS = [keyCodes_1.keyCodes.ENTER, keyCodes_1.keyCodes.SPACE];
function useIconProps({ onClick, className, clickable, ignoreFocusStyle, isDecorationOnly, iconLabel, externalTabIndex }) {
    const iconRef = (0, react_1.useRef)(null);
    const onEnterCallback = (0, react_1.useCallback)((event) => {
        const isActive = document.activeElement === iconRef.current;
        if (!isActive) {
            return;
        }
        onClick(event);
    }, [iconRef, onClick]);
    const onMouseDown = (0, react_1.useCallback)((event) => {
        event.preventDefault();
    }, []);
    const computedClassName = (0, react_1.useMemo)(() => {
        return (0, classnames_1.default)("icon_component", className, {
            "icon_component--clickable": clickable,
            "icon_component--no-focus-style": ignoreFocusStyle
        });
    }, [clickable, className, ignoreFocusStyle]);
    (0, useEventListener_1.default)({
        eventName: "mousedown",
        callback: onMouseDown,
        ref: iconRef
    });
    (0, useKeyEvent_1.default)({
        keys: KEYS,
        ref: iconRef,
        callback: onEnterCallback,
        ignoreDocumentFallback: true,
        capture: true,
        stopPropagation: true,
        preventDefault: true
    });
    const onClickCallback = (0, react_1.useCallback)((event) => {
        const callback = onClick || lodash_es_1.noop;
        callback(event);
    }, [onClick]);
    const screenReaderAccessProps = (0, useIconScreenReaderAccessProps_1.default)({
        isClickable: clickable,
        label: iconLabel,
        isDecorationOnly
    });
    screenReaderAccessProps.tabIndex = externalTabIndex !== null && externalTabIndex !== void 0 ? externalTabIndex : screenReaderAccessProps.tabIndex;
    return {
        screenReaderAccessProps,
        onClickCallback,
        computedClassName,
        onEnterCallback,
        iconRef
    };
}
exports.default = useIconProps;
